import enUS from './locale/en-US';
import zhCN from './locale/zh-CN';

export const INTL_LOCALE_SELECT = {
  EN_US: {
    TEXT: 'English',
    NAME: 'EN_US',
  },
  ZH_CN: {
    TEXT: '中文',
    NAME: 'ZH_CN',
  },
};

export const INTL_LOCALES = {
  EN_US: enUS,
  ZH_CN: zhCN,
};
